import { render, staticRenderFns } from "./VideoRoomContainer.vue?vue&type=template&id=00fa6312&scoped=true"
import script from "./VideoRoomContainer.vue?vue&type=script&lang=js"
export * from "./VideoRoomContainer.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomContainer.vue?vue&type=style&index=0&id=00fa6312&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa6312",
  null
  
)

export default component.exports